import { GlAlert } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { BV_SHOW_MODAL } from '~/lib/utils/constants';
import WikiHeader from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_header.vue?vue3';
import WikiContent from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_content.vue?vue3';
import WikiForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_form.vue?vue3';
import WikiAlert from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_alert.vue?vue3';
import WikiNotesApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/wiki_notes/components/wiki_notes_app.vue?vue3';
export default {
    name: 'WikisApp',
    components: {
        GlAlert,
        WikiHeader,
        WikiContent,
        WikiForm,
        WikiAlert,
        WikiNotesApp
    },
    inject: {
        isPageHistorical: {
            default: null
        },
        wikiUrl: {
            default: null
        },
        historyUrl: {
            default: null
        },
        error: {
            default: null
        },
        pagePersisted: {
            default: false
        }
    },
    i18n: {
        alertText: s__('WikiHistoricalPage|This is an old version of this page.'),
        alertPrimaryButton: s__('WikiHistoricalPage|Go to most recent version'),
        alertSecondaryButton: s__('WikiHistoricalPage|Browse history')
    },
    data () {
        return {
            isEditing: false
        };
    },
    computed: {
        showWikiNotes () {
            return !this.isCustomSidebar && (!this.isEditing || this.pagePersisted);
        },
        showWikiHeader () {
            return !this.isEditing;
        },
        isCustomSidebar () {
            return this.wikiUrl.endsWith('_sidebar');
        }
    },
    watch: {
        isEditing () {
            // sync the mode with the URL to ensure the state survives a page reload
            const url = new URL(window.location);
            if (this.isEditing) {
                url.searchParams.set('edit', 'true');
            } else {
                url.searchParams.delete('edit');
                url.searchParams.delete('view');
            }
            window.history.pushState({}, '', url);
        }
    },
    mounted () {
        this.checkEditingMode();
        this.checkOpenCloneModal();
        window.addEventListener('popstate', this.checkEditingMode);
    },
    beforeDestroy () {
        window.removeEventListener('popstate', this.checkEditingMode);
    },
    methods: {
        setEditingMode (value) {
            this.isEditing = value;
        },
        checkEditingMode () {
            const url = new URL(window.location);
            if (url.searchParams.has('edit') || url.searchParams.get('view') === 'create' || this.error) {
                this.setEditingMode(true);
            } else {
                this.setEditingMode(false);
            }
        },
        checkOpenCloneModal () {
            const url = new URL(window.location);
            if (url.searchParams.has('open_clone_modal')) {
                url.searchParams.delete('open_clone_modal');
                window.history.replaceState({}, '', url);
                this.$root.$emit(BV_SHOW_MODAL, 'clone-wiki-modal');
            }
        }
    }
};
